<template>
    <div>
        <button
            @click="addPPHPTender"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah PPHPTender
        </button>
        <div
            v-for="(pphptender, pphptenderIndex) in pphptenderList"
            :key="pphptender.id || pphptenderIndex"
            class="pphptender-entry mb-3"
        >
            <div class="lg:w-full md:w-full">
                <div class="flex items-center gap-2">
                    <Dropdown
                        class="w-full"
                        v-model="pphptenderList[pphptenderIndex].id"
                        :options="filteredPPHPTenderOptions(pphptender.id)"
                        optionLabel="fullname"
                        optionValue="id"
                        filter
                        filterBy="fullname"
                        @filter="fetchPPHPTender"
                        @change="validateUniqueness(pphptenderIndex)"
                        placeholder="Pilih Panitia Penerima Hasil Perkerjaan"
                    />
                    <button
                        @click="removePPHPTender(pphptenderIndex)"
                        class="px-4 py-2 bg-red-500 text-white rounded ml-2"
                    >
                        Hapus
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import axios from "axios";

export default defineComponent({
    components: {
        Dropdown,
    },
    props: {
        list_pphptender: Array,
        pphptender_id : String,
    },
    data() {
        const pphptenderInitialList = this.list_pphptender
            ? this.list_pphptender.map((item, idx) => ({
                ...item,
                pphptenderUniqueId: item.pphptenderUniqueId || this.pphptenderGenerateUniqueId(),
                pphptenderDisplayIndex: idx + 1
            }))
            : [];
        return {
            pphptenderOptions: [],
            pphptenderList: pphptenderInitialList,
            pphptenderNextIndex: (pphptenderInitialList.length > 0)
                ? Math.max(...pphptenderInitialList.map(item => item.pphptenderDisplayIndex || 0)) + 1
                : 1
        };
    },
    watch: {
        list_pphptender: {
            handler(pphptenderNewValue) {
                if (pphptenderNewValue) {
                    // Block recursive updates by checking if the internal change is happening
                    if (this._internalUpdate) return;
                    
                    // Preserve pphptenderUniqueIds if present, generate new ones if not
                    this.pphptenderList = pphptenderNewValue.map((item, idx) => ({
                        ...item,
                        pphptenderUniqueId: item.pphptenderUniqueId || this.pphptenderGenerateUniqueId(),
                        pphptenderDisplayIndex: item.pphptenderDisplayIndex || (idx + 1)
                    }));
                    
                    // Update pphptenderNextIndex based on highest current pphptenderDisplayIndex
                    if (this.pphptenderList.length > 0) {
                        this.pphptenderNextIndex = Math.max(
                            ...this.pphptenderList.map(item => item.pphptenderDisplayIndex || 0)
                        ) + 1;
                    }
                } else {
                    this.pphptenderList = [];
                    this.pphptenderNextIndex = 1;
                }
            },
            deep: true,
        },
        pphptenderList: {
            handler(pphptenderNewValue) {
                // Prevent recursive updates by setting a flag
                this._internalUpdate = true;
                // Emit the updated pphptenderList to the parent component
                this.$emit("update:list_pphptender", pphptenderNewValue);
                // Reset flag after this update cycle
                this.$nextTick(() => {
                    this._internalUpdate = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.fetchPPHPTender({ value: "" });
    },
    methods: {
        pphptenderGenerateUniqueId(){
            return Date.now() + '-' + Math.floor(Math.random() * 100);
        },
        addPPHPTender() {
            this.pphptenderList.push({
                id: null,
                pphptenderUniqueId : this.pphptenderGenerateUniqueId(),
                pphptenderDisplayIndex : this.pphptenderNextIndex
            });
            this.pphptenderNextIndex++;
        },
        removePPHPTender(pphptenderIndex) {
            this.pphptenderList.splice(pphptenderIndex, 1);
        },
        async fetchPPHPTender(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_pphp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.pphptenderOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching pphptender:", error);
            }
        },
        filteredPPHPTenderOptions(pphptenderCurrentId) {
            // Ensure the currently selected option is available in the dropdown options
            return this.pphptenderOptions.concat(
                this.pphptenderList.filter(
                    (p) =>
                        p.id === pphptenderCurrentId &&
                        !this.pphptenderOptions.some(
                            (option) => option.id === pphptenderCurrentId
                        )
                )
            );
        },
        validateUniqueness(pphptenderCurrentIndex) {
            const pphptenderCurrentId = this.pphptenderList[pphptenderCurrentIndex]?.id;
            if (
                pphptenderCurrentId &&
                this.pphptenderList.filter(
                    (pphptender) => pphptender.id === pphptenderCurrentId
                ).length > 1
            ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "PPHPTender duplikat terdeteksi. Pastikan setiap pphptender unik.",
                    life: 3000,
                });
                this.pphptenderList[pphptenderCurrentIndex].id = null;
            }
        },
    },
});
</script>
